/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_FeaturesInputs */

const fr_welcome_back_features = /** @type {(inputs: Welcome_Back_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ensemble des fonctionnalités ont été reprises sur cette nouvelle version.`)
};

const en_welcome_back_features = /** @type {(inputs: Welcome_Back_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All features have been carried over to this new version.`)
};

/**
* | output |
* | --- |
* | "All features have been carried over to this new version." |
*
* @param {Welcome_Back_FeaturesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_features = /** @type {((inputs?: Welcome_Back_FeaturesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_FeaturesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_features(inputs)
	return en_welcome_back_features(inputs)
});